import { AntDesign, EvilIcons, MaterialIcons } from "@expo/vector-icons";
import React, { Component } from "react";
import {
  KeyboardAvoidingView,
  RefreshControl,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  FlatList,
  Platform
} from "react-native";
import BackHeader from "../../../Components/BackHeader";
import { Layout, colors, spaceSize, fontSize } from "../../../Themes";
import { Types as ACCOUNT_TYPE } from "../../../Models/Reducers/AccountReducer";
export default class TeacherScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAccount: {},
      listAccount: this.props.listAccount,
      refreshing: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.accountType !== "") {
      switch (nextProps.accountType) {
        case ACCOUNT_TYPE.GET_ACCOUNTS_SUCCESS:
          this.setState({
            listAccount: [...nextProps.listAccount]
          });
          break;
        case ACCOUNT_TYPE.REGISTER_FAIL:
          alert(nextProps.accountMess);
          break;
        case ACCOUNT_TYPE.DELETE_ACCOUNT_FAIL:
          alert(nextProps.accountMess);
          break;
        case ACCOUNT_TYPE.REGISTER_SUCCESS:
          this.props.getAccounts();
          this.onInsert();
          break;
        case ACCOUNT_TYPE.DELETE_ACCOUNT_SUCCESS:
          this.props.getAccounts();
          this.onInsert();
          break;
      }
    }
  }

  componentDidMount() {
    if (this.state.listAccount.length > 0) {
      this.props.selectAccount(this.state.listAccount[0]);
      this.setState({ selectedAccount: this.state.listAccount[0] });
    }
    this.props.getAccounts();
  }

  routeTo = (screen, params) => {
    this.props.navigation.navigate({
      routeName: screen,
      params
    });
  };

  onInsert = () => {
    if (Platform.OS === "web") {
      this.setState({ selectedAccount: null });
      this.props.newAccount();
    } else this.routeTo("TeacherDetailScreen", {});
  };

  onUpdate = account => {
    if (Platform.OS === "web") {
      this.setState({ selectedAccount: account });
      this.props.selectAccount(account);
    }
  };
  onDelete = account => {
    if (account.uuid) {
      this.props.deleteAccount(account.uuid);
    }
  };
  render() {
    const { selectedAccount } = this.state;
    return (
      <View style={[styles.container]}>
        {Platform.OS !== "web" && (
          <BackHeader
            goBack={() => this.props.navigation.goBack()}
            title={"Danh sách giảng viên"}
          />
        )}
        <KeyboardAvoidingView
          style={{ flex: 1, marginBottom: Layout.minerScale(12) }}
          behavior="padding"
          enabled
          keyboardVerticalOffset={Layout.minerScale(24)}
        >
          <TouchableOpacity
            style={styles.insertAction}
            onPress={() => this.onInsert()}
          >
            <EvilIcons name="plus" style={styles.insertIcon} />
          </TouchableOpacity>
          <FlatList
            style={{ flex: 1 }}
            refreshing={this.state.refreshing}
            onRefresh={() => {
              this.props.getAccounts();
            }}
            data={this.state.listAccount}
            keyExtractor={this._keyExtractor}
            extraData={this.state || this.props}
            scrollEventThrottle={16}
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
            renderItem={({ item, index }) => (
              <View key={index}>
                <TouchableOpacity
                  style={styles.lineContainer}
                  onPress={() => this.onUpdate(item)}
                >
                  <View
                    style={{
                      width: fontSize.largest,
                      alignItems: "center"
                    }}
                  >
                    {Platform.OS === "web" ? (
                      !!selectedAccount &&
                      selectedAccount.uuid === item.uuid && (
                        <MaterialIcons
                          name="bookmark-border"
                          style={styles.icon}
                        />
                      )
                    ) : (
                      <MaterialIcons
                        name="bookmark-border"
                        style={styles.icon}
                      />
                    )}
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text style={styles.textInput}>{item.name}</Text>
                  </View>
                  <TouchableOpacity onPress={() => this.onDelete(item)}>
                    <AntDesign
                      name="delete"
                      style={[
                        styles.icon,
                        {
                          paddingRight: Layout.minerScale(24),
                          color: colors.buttonDelete
                        }
                      ]}
                    />
                  </TouchableOpacity>
                </TouchableOpacity>
                <View style={styles.line}></View>
              </View>
            )}
          />
        </KeyboardAvoidingView>
      </View>
    );
  }
}

TeacherScreen.navigationOptions = {
  header: null,
  drawerLockMode: "locked-closed"
};

const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  insertAction: {
    height: Layout.minerScale(48),
    borderWidth: Layout.minerScale(1),
    borderColor: "rgb(220,220,220)",
    margin: Layout.minerScale(12),
    borderRadius: Layout.minerScale(12),
    borderStyle: "dashed",
    alignItems: "center",
    justifyContent: "center"
  },
  insertIcon: {
    color: "rgb(220,220,220)",
    fontSize: Layout.minerScale(42)
  },
  lineContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    height: Layout.minerScale(50),
    marginVertical: spaceSize.padding.small
  },
  textInput: {
    fontSize: fontSize.largest,
    marginLeft: spaceSize.margin.medium,
    color: colors.textBody
  },
  icon: {
    color: colors.textBody,
    fontSize: fontSize.largest
  },
  line: {
    width: "100%",
    backgroundColor: colors.line,
    height: 1
  }
});
